export const SET_ACTIVE_OPTION = 'SET_ACTIVE_OPTION';
